import { CREATOR_FILTER_DATE_RANGE } from '@/entities/discovery';

import { getPlatformName, SOURCE_PLATFORM_TYPE } from '@/entities/public-filter';
import type { FilterConditions } from '@/entities/discovery';
import {
  DATE_RANGE_CONFIG,
  parseDateRangeToEnum,
} from '@/entities/discovery/utils/creator-date-range-parser';

export function getPlatformLabel(filters: FilterConditions) {
  if (!filters.platform?.length) return 'All platforms';

  return filters.platform.map(getPlatformName).join(', ');
}

export function arePlatformSelectionsEqual(
  left: FilterConditions['platform'],
  right: FilterConditions['platform'],
) {
  const leftValues = [...new Set(left ?? [])].sort();
  const rightValues = [...new Set(right ?? [])].sort();

  return (
    leftValues.length === rightValues.length &&
    leftValues.every((value, index) => value === rightValues[index])
  );
}

export function getTimeRangeLabel(filters: FilterConditions) {
  const dateRange = parseDateRangeToEnum(
    {
      start_date: filters.start_date,
      end_date: filters.end_date,
    },
    CREATOR_FILTER_DATE_RANGE.LAST_60_DAYS,
  );

  return DATE_RANGE_CONFIG.get(dateRange)?.label ?? 'Time range';
}

export const getPlatformUrl = (platform: SOURCE_PLATFORM_TYPE, username: string) => {
  const urlEncodedName = encodeURI(username);
  switch (platform) {
    case SOURCE_PLATFORM_TYPE.TIKTOK:
      return `https://www.tiktok.com/@${urlEncodedName}`;
    case SOURCE_PLATFORM_TYPE.INSTAGRAM:
      return `https://www.instagram.com/${urlEncodedName}`;
    case SOURCE_PLATFORM_TYPE.YOUTUBE:
      return `https://www.youtube.com/@${urlEncodedName}`;
    default:
      return '#';
  }
};
